



















































































































import { Component, Vue } from 'vue-property-decorator';
import { requestPassword, requestSupportPasswordReset } from '../../api/api';
import get from 'lodash/get';
import ButtonLoading from '@/components/ButtonLoading.vue';

@Component({
    components: {
        ButtonLoading,
    },
})
export default class ForgotPassword extends Vue {
    email: string = '';
    error: string | null = null;
    loading: boolean = false;
    showStarterPopup: boolean = false;
    
    async onSubmit() {
        this.loading = true;
        const $vs = (this as any).$vs;
        if (this.email === '') {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `L'e-mail est requis.`,
            });
            this.error = `L'e-mail n'est pas valide.`;
            this.loading = false;
            return;
        }
        if (!/.+@.+\..+/.test(this.email)) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `L'e-mail n'est pas valide.`,
            });
            this.error = `L'e-mail n'est pas valide.`;
            this.loading = false;
            return;
        }
        try {
            await requestPassword(this.email);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Récupération de mot de passe',
                text: `Un mail avec un lien pour regénérer votre mot de passe vient de vous être envoyé.`,
            });
            this.$router.push({ name: 'login' });
        } catch (error) {
            const errorMessage = get(error, 'response.data.message', '');
            const errorCode = get(error, 'response.data.code', '');
            
            // Si l'API retourne une erreur spécifique pour les utilisateurs Starter
            if (errorCode === 403 && errorMessage.includes('Starter')) {
                // Afficher la popup sans rediriger
                this.showStarterPopup = true;
            } else {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: get(
                        error,
                        'response.data.message',
                        'Erreur lors de la soumission du formulaire'
                    ),
                });
                this.error = get(
                    error,
                    'response.data.message',
                    'Erreur lors de la soumission du formulaire'
                );
            }
        } finally {
            this.loading = false;
        }
    }

    async handleSupportRequest() {
    this.loading = true;
    const $vs = (this as any).$vs;
    
    try {
        // Appeler le nouvel endpoint API pour demander l'assistance du support
        await requestSupportPasswordReset(this.email);
        
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Demande envoyée',
            text: `Votre demande a été transmise à notre équipe de support. Nous vous contacterons prochainement.`,
        });
        
        // Fermer la popup et rediriger vers login
        this.showStarterPopup = false;
        this.$nextTick(() => {
            this.$router.push({ name: 'login' });
        });
    } catch (error) {
        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur',
            text: 'Une erreur est survenue lors de l\'envoi de votre demande. Veuillez réessayer.',
        });
    } finally {
        this.loading = false;
    }
}
    
    handlePopupClose() {
        // Fermer la popup
        this.showStarterPopup = false;
        // Attendre que la popup soit vraiment fermée avant de rediriger
        this.$nextTick(() => {
            this.$router.push({ name: 'login' });
        });
    }
}
